module.exports = __webpack_public_path__ + "static/slider_2a2-d464eda7049d00f1383700dcad78ef02.jpg";